import { useTheme } from '@material-ui/core/styles';
import { CustomTheme } from './themeTypes';

export default (): CustomTheme => useTheme();
